// extracted by mini-css-extract-plugin
module.exports = {"root":"WebshopSorting_root__2zSnB","text":"WebshopSorting_text__COMu5","selectHolder":"WebshopSorting_selectHolder__14tqg"};